import Collapse from './components/Collapse';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'collapse',
  pluginComponent: Collapse,
});
